import { render, staticRenderFns } from "./prices.vue?vue&type=template&id=4a423b5c&lang=pug&"
import script from "./prices.vue?vue&type=script&lang=js&"
export * from "./prices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports